import { gql } from '@apollo/client';
import { EntityCategoryFragment } from '../entityCategories';
import { BasicFieldValueFragment } from '../fields';

export const BasicEventValueFragment = gql`
  fragment BasicEventValueFields on BasicEventValue {
    value {
      ...BasicFieldValueFields
    }
    categories {
      ...EntityCategoryFields
    }
    isFavorite
    isManaged
    kind
    tableNames
  }
  ${BasicFieldValueFragment}
  ${EntityCategoryFragment}
`;

export const DictionaryBasicEventFragment = gql`
  fragment DictionaryBasicEventFields on DictionaryBasicEvent {
    key
    name
    description
    isDisabled
    isRenamed
    entityCategories {
      ...EntityCategoryFields
    }
    isFavorite
    isManaged
    tableNames
  }
  ${EntityCategoryFragment}
`;
